import { render, staticRenderFns } from "./modal_task.vue?vue&type=template&id=b760612e"
import script from "./modal_task.vue?vue&type=script&lang=js"
export * from "./modal_task.vue?vue&type=script&lang=js"
import style0 from "./modal_task.vue?vue&type=style&index=0&id=b760612e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports